(() => {
  const defaults = window.customUserCartDefaults;
  const calendarSelector = '#cc-calendar-overall';
  const calendarSelectSelector = '#cc-calendar-overall #cc-select-days-opt';
  const calendarAnchorSelector = '#cart-calendar-anchor';
  const calendarMoveBoundarySelector =
    '#main-cart-footer, .cart__blocks, .cart__summary, .cart__footer, .js-contents, .page-width, .shopify-section';

  const hasMatchingNode = (node, selector) => {
    if (!(node instanceof Element)) return false;
    return node.matches(selector) || Boolean(node.querySelector(selector));
  };

  const getMovableCalendarNode = (calendarRoot) => {
    let movableNode = calendarRoot;

    while (movableNode.parentElement && movableNode.parentElement !== document.body) {
      const parent = movableNode.parentElement;

      if (parent.matches(`${calendarAnchorSelector}, ${calendarMoveBoundarySelector}`)) break;

      const elementChildren = Array.from(parent.children).filter((child) => {
        return child.tagName !== 'SCRIPT' && child.tagName !== 'STYLE';
      });

      if (elementChildren.length !== 1) break;

      movableNode = parent;
    }

    return movableNode;
  };

  const relocateCalendar = () => {
    const anchor = document.querySelector(calendarAnchorSelector);
    const calendarRoot = document.querySelector(calendarSelector);

    if (!anchor || !calendarRoot) return false;

    const movableNode = getMovableCalendarNode(calendarRoot);

    if (movableNode.parentElement === anchor) return true;

    anchor.appendChild(movableNode);
    return true;
  };

  let scan = () => {};

  if (defaults) {
    const prefectures = [
      { jp: '北海道', code: 'JP-01', aliases: ['hokkaido'] },
      { jp: '青森県', code: 'JP-02', aliases: ['aomori'] },
      { jp: '岩手県', code: 'JP-03', aliases: ['iwate'] },
      { jp: '宮城県', code: 'JP-04', aliases: ['miyagi'] },
      { jp: '秋田県', code: 'JP-05', aliases: ['akita'] },
      { jp: '山形県', code: 'JP-06', aliases: ['yamagata'] },
      { jp: '福島県', code: 'JP-07', aliases: ['fukushima'] },
      { jp: '茨城県', code: 'JP-08', aliases: ['ibaraki'] },
      { jp: '栃木県', code: 'JP-09', aliases: ['tochigi'] },
      { jp: '群馬県', code: 'JP-10', aliases: ['gunma'] },
      { jp: '埼玉県', code: 'JP-11', aliases: ['saitama'] },
      { jp: '千葉県', code: 'JP-12', aliases: ['chiba'] },
      { jp: '東京都', code: 'JP-13', aliases: ['tokyo', 'tokyo-to'] },
      { jp: '神奈川県', code: 'JP-14', aliases: ['kanagawa'] },
      { jp: '新潟県', code: 'JP-15', aliases: ['niigata'] },
      { jp: '富山県', code: 'JP-16', aliases: ['toyama'] },
      { jp: '石川県', code: 'JP-17', aliases: ['ishikawa'] },
      { jp: '福井県', code: 'JP-18', aliases: ['fukui'] },
      { jp: '山梨県', code: 'JP-19', aliases: ['yamanashi'] },
      { jp: '長野県', code: 'JP-20', aliases: ['nagano'] },
      { jp: '岐阜県', code: 'JP-21', aliases: ['gifu'] },
      { jp: '静岡県', code: 'JP-22', aliases: ['shizuoka'] },
      { jp: '愛知県', code: 'JP-23', aliases: ['aichi'] },
      { jp: '三重県', code: 'JP-24', aliases: ['mie'] },
      { jp: '滋賀県', code: 'JP-25', aliases: ['shiga'] },
      { jp: '京都府', code: 'JP-26', aliases: ['kyoto', 'kyoto-fu'] },
      { jp: '大阪府', code: 'JP-27', aliases: ['osaka', 'osaka-fu'] },
      { jp: '兵庫県', code: 'JP-28', aliases: ['hyogo', 'hyogo-ken'] },
      { jp: '奈良県', code: 'JP-29', aliases: ['nara'] },
      { jp: '和歌山県', code: 'JP-30', aliases: ['wakayama'] },
      { jp: '鳥取県', code: 'JP-31', aliases: ['tottori'] },
      { jp: '島根県', code: 'JP-32', aliases: ['shimane'] },
      { jp: '岡山県', code: 'JP-33', aliases: ['okayama'] },
      { jp: '広島県', code: 'JP-34', aliases: ['hiroshima'] },
      { jp: '山口県', code: 'JP-35', aliases: ['yamaguchi'] },
      { jp: '徳島県', code: 'JP-36', aliases: ['tokushima'] },
      { jp: '香川県', code: 'JP-37', aliases: ['kagawa'] },
      { jp: '愛媛県', code: 'JP-38', aliases: ['ehime'] },
      { jp: '高知県', code: 'JP-39', aliases: ['kochi', 'kohchi'] },
      { jp: '福岡県', code: 'JP-40', aliases: ['fukuoka'] },
      { jp: '佐賀県', code: 'JP-41', aliases: ['saga'] },
      { jp: '長崎県', code: 'JP-42', aliases: ['nagasaki'] },
      { jp: '熊本県', code: 'JP-43', aliases: ['kumamoto'] },
      { jp: '大分県', code: 'JP-44', aliases: ['oita', 'ooita'] },
      { jp: '宮崎県', code: 'JP-45', aliases: ['miyazaki'] },
      { jp: '鹿児島県', code: 'JP-46', aliases: ['kagoshima'] },
      { jp: '沖縄県', code: 'JP-47', aliases: ['okinawa'] },
    ];

    const normalize = (value) =>
      String(value || '')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase()
        .replace(/[‐‑–—ーｰ]/g, '-')
        .replace(/\s+/g, '');

    const prefectureMap = prefectures.reduce((map, prefecture) => {
      map[normalize(prefecture.jp)] = prefecture.jp;
      map[normalize(prefecture.code)] = prefecture.jp;
      prefecture.aliases.forEach((alias) => {
        map[normalize(alias)] = prefecture.jp;
      });
      return map;
    }, {});

    const provinceCandidates = Array.from(
      new Set(
        [defaults.province, defaults.province_code]
          .filter(Boolean)
          .flatMap((value) => {
            const trimmedValue = String(value).trim();
            const mappedValue = prefectureMap[normalize(trimmedValue)];

            return mappedValue ? [trimmedValue, mappedValue] : [trimmedValue];
          })
      )
    );

    if (provinceCandidates.length) {
      const isMeaningfulSelection = (select) => {
        const currentOption = Array.from(select.options).find((option) => option.value === select.value);
        return Boolean(currentOption && currentOption.value);
      };

      const getMatchingOption = (select) =>
        Array.from(select.options).find((option) => {
          const optionValues = [option.value, option.textContent].map(normalize).filter(Boolean);

          return provinceCandidates.some((candidate) => optionValues.includes(normalize(candidate)));
        });

      const isCalendarBlocked = (widgetRoot) =>
        Boolean(widgetRoot.querySelector('.cc-select-days-remarks')) ||
        Array.from(widgetRoot.querySelectorAll('.cc-calendar-input')).some((element) => element.style.display === 'none');

      const dispatchSelection = (select, optionValue) => {
        select.value = optionValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      };

      const retrySelection = (select, widgetRoot, optionValue, delay) => {
        window.setTimeout(() => {
          if (!select.isConnected || !widgetRoot.contains(select)) return;
          if (!isCalendarBlocked(widgetRoot)) return;
          dispatchSelection(select, optionValue);
        }, delay);
      };

      const applyDefaultProvince = (select, allowRetry = true) => {
        if (!(select instanceof HTMLSelectElement)) return false;
        if (!select.isConnected || select.options.length <= 1) return false;
        if (isMeaningfulSelection(select)) return false;

        const matchingOption = getMatchingOption(select);

        if (!matchingOption) return false;

        const widgetRoot = select.closest(calendarSelector) || document;
        dispatchSelection(select, matchingOption.value);
        select.dataset.defaultProvinceApplied = 'true';

        if (!allowRetry) return true;

        retrySelection(select, widgetRoot, matchingOption.value, 250);
        retrySelection(select, widgetRoot, matchingOption.value, 800);

        return true;
      };

      const tryApplyToSelect = (select) => {
        if (!select.closest(calendarSelector)) return;
        if (isMeaningfulSelection(select)) return;

        if (applyDefaultProvince(select)) return;

        window.setTimeout(() => applyDefaultProvince(select, false), 150);
        window.setTimeout(() => applyDefaultProvince(select, false), 500);
      };

      scan = () => {
        document.querySelectorAll(calendarSelectSelector).forEach((select) => {
          tryApplyToSelect(select);
        });
      };
    }
  }

  const init = () => {
    relocateCalendar();
    scan();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  const observer = new MutationObserver((mutations) => {
    const shouldProcess = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some((node) => {
        return (
          hasMatchingNode(node, calendarAnchorSelector) ||
          hasMatchingNode(node, calendarSelector) ||
          hasMatchingNode(node, calendarSelectSelector)
        );
      })
    );

    if (!shouldProcess) return;

    relocateCalendar();
    scan();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
